import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Project } from '../models/project';
import { extractErrorMessage } from '../utils/utils';
import { SimilarityList } from '../models/similarity-list';

export interface ProjectSimilarityCheckPayload {
  id: number | null;
  shortName: string | null;
  fullName: string | null;
}
export interface ProjectSimilarityRecord {
  id: number;
  shortName: string;
  fullName: string;
  nameSimilarity: number;
  fullNameSimilarity: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  baseUrl: string = environment.api_url;
  constructor(private readonly http: HttpClient) { }

  checkForSimilarProjects(data: ProjectSimilarityCheckPayload): Observable<SimilarityList<ProjectSimilarityRecord>> {
    let params = new HttpParams();
    for (const key in data) {
      const value = (data as any)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    }
    return this.http.get<SimilarityList<ProjectSimilarityRecord>>(`${this.baseUrl}/projects/similar`, { params }).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }


  // GET all projects
  getAllProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(`${this.baseUrl}/projects`).pipe(
      map(list => list.map(dto => new Project(dto))),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET all projects
  getSortedProjects(sortBy: string): Observable<Project[]> {
    return this.http.get<Project[]>(`${this.baseUrl}/projects?sort=${sortBy}`).pipe(
      map(list => list.map(dto => new Project(dto))),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  // GET single project by ID
  getProjectById(id: number): Observable<Project> {
    return this.http.get<Project>(`${this.baseUrl}/projects/${id}`).pipe(
      map(dto => new Project(dto)),
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  create(project: Project): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/projects`, project).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
  update(project: Project): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/projects/${project.id}`, project).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/projects/${id}`).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
}
